import useAxios from "../../hooks/useAxios";

const useSpectateTrlService = () => {
  const axiosGetAllTrl = useAxios();

  const getTrlFromAppId = async (posId) => {
    await axiosGetAllTrl.fetchData({
      url: `/approver/trl/${posId}`,
      method: "GET",
    });
  };

  return {
    // list
    getTrlFromAppId,
    trlLoading: axiosGetAllTrl.loading,
    trlResponse: axiosGetAllTrl.response,
  };
};

export default useSpectateTrlService;
